import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ThemeMode } from '@/constants/types';
import { APP_CONFIG } from '@/constants/app';
import { COLORS } from '@/constants/colors';

const getInitialTheme = (): 'light' | 'dark' => {
  const saved = localStorage.getItem(APP_CONFIG.THEME_KEY);
  if (saved === 'light' || saved === 'dark') {
    return saved;
  }
  // Default to light mode instead of system preference
  return 'light';
};

const getInitialColors = () => {
  const savedPrimary = localStorage.getItem('primaryColor');
  const savedSecondary = localStorage.getItem('secondaryColor');
  return {
    primary: savedPrimary || COLORS.PRIMARY.MAIN,
    secondary: savedSecondary || COLORS.SECONDARY.MAIN,
  };
};

const initialState: ThemeMode = {
  mode: getInitialTheme(),
  colors: getInitialColors(),
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
      localStorage.setItem(APP_CONFIG.THEME_KEY, state.mode);
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.mode = action.payload;
      localStorage.setItem(APP_CONFIG.THEME_KEY, state.mode);
    },
    setPrimaryColor: (state, action: PayloadAction<string>) => {
      state.colors.primary = action.payload;
      localStorage.setItem('primaryColor', action.payload);
    },
    setSecondaryColor: (state, action: PayloadAction<string>) => {
      state.colors.secondary = action.payload;
      localStorage.setItem('secondaryColor', action.payload);
    },
    setCustomColors: (state, action: PayloadAction<{ primary: string; secondary: string }>) => {
      state.colors.primary = action.payload.primary;
      state.colors.secondary = action.payload.secondary;
      localStorage.setItem('primaryColor', action.payload.primary);
      localStorage.setItem('secondaryColor', action.payload.secondary);
    },
  },
});

export const { toggleTheme, setTheme, setPrimaryColor, setSecondaryColor, setCustomColors } = themeSlice.actions;
export default themeSlice.reducer;